import { render, staticRenderFns } from "./XmUploadFileName.vue?vue&type=template&id=1840ffbf&scoped=true"
import script from "./XmUploadFileName.vue?vue&type=script&lang=js"
export * from "./XmUploadFileName.vue?vue&type=script&lang=js"
import style0 from "./XmUploadFileName.vue?vue&type=style&index=0&id=1840ffbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840ffbf",
  null
  
)

export default component.exports